<template>
    <div class="c-t-default">
        <site-header></site-header>
        <transition name="o-transition--fade" mode="out-in">
            <div
                v-if="!isLoading && !error && post != null && post.acf"
                key="content"
            >
                <hero :hero="post.acf.hero"></hero>
                <sections-wrapper
                    :sections="post.acf.sections"
                ></sections-wrapper>
            </div>
            <div v-else-if="!isLoading && error" key="error">
                <error-state></error-state>
            </div>
            <div v-else key="loading">
                <loader class="c-m-loader--x-large"></loader>
            </div>
        </transition>
        <site-footer></site-footer>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
    FETCH_CONTENT_BY_SLUG,
    GET_CONTENT,
    GET_ERROR,
    IS_LOADING
} from "../store/store-models/content-model";

import SectionsWrapper from "./SectionsWrapper.vue";
import ErrorState from "./components/molecules/MoleculeErrorState.vue";
import Loader from "./components/molecules/MoleculeLoader.vue";
import Hero from "./components/organisms/OrganismHeroHome.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";

export default {
    async asyncData({ store, route }) {
        return store.dispatch(FETCH_CONTENT_BY_SLUG, "startsida");
    },
    components: {
        SiteHeader,
        Hero,
        SectionsWrapper,
        SiteFooter,
        Loader,
        ErrorState
    },
    computed: {
        ...mapGetters({
            post: GET_CONTENT,
            isLoading: IS_LOADING,
            error: GET_ERROR
        })
    },
    metaData() {
        return {
            title: "Hem",
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content:
                        "Hitta kvalitetssäkrade hantverkare enkelt och tryggt. Gratis förfrågan och upp till 6 snabba svar från bra hantverkare nära dig."
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `${process.env.SITE_BASE_URL}${this.$route.path}`
                }
            ]
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue